import { createFileRoute, redirect } from "@tanstack/react-router";
import { homeRedirectHref } from "../lib/home-redirect";

export const Route = createFileRoute("/")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: homeRedirectHref(location.href), statusCode: 301 });
  },
});
